var _path, _path2, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKhcLogo = function SvgKhcLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 410,
    height: 150
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#136538",
    d: "M0 0h410v150H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    d: "M6 6h398v140H6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6h12v140H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 75 80 5h5L35 75zM10 75l70 70h5L35 75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 6h8v140h-8z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 65,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 60,
    fontWeight: "bold"
  }, "\n    Keith\u2019s\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 125,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 60,
    fontWeight: "bold"
  }, "\n    Haircenter\n  ")));
};
export { SvgKhcLogo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEwIiBoZWlnaHQ9IjE1MCIgdmlld0JveD0iMCAwIDQxMCAxNTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPCEtLSBCYWNrZ3JvdW5kIC0tPgogIDxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSI0MTAiIGhlaWdodD0iMTUwIiBmaWxsPSIjMTM2NTM4Ii8+CgogIDwhLS0gQm9yZGVyIC0tPgogIDxyZWN0IHg9IjYiIHk9IjYiIHdpZHRoPSIzOTgiIGhlaWdodD0iMTQwIiBmaWxsPSJub25lIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjQiLz4KCiAgPCEtLSBMZWZ0ICJLIiBzaGFwZSAtLT4KICA8ZyBmaWxsPSJ3aGl0ZSI+CiAgICA8IS0tIFZlcnRpY2FsIGJhciAtLT4KICAgIDxyZWN0IHg9IjUiIHk9IjYiIHdpZHRoPSIxMiIgaGVpZ2h0PSIxNDAiLz4KICAgIAogICAgPCEtLSBUb3AgZGlhZ29uYWwgLS0+CiAgICA8cG9seWdvbiBwb2ludHM9IjEwLDc1IDgwLDUgODUsNSAzNSw3NSIvPgogICAgCiAgICA8IS0tIEJvdHRvbSBkaWFnb25hbCAtLT4KICAgICA8cG9seWdvbiBwb2ludHM9IjEwLDc1IDgwLDE0NSA4NSwxNDUgMzUsNzUiLz4KCiAgICA8IS0tIFZlcnRpY2FsIGJhciAyIC0tPgogICAgPHJlY3QgeD0iODAiIHk9IjYiIHdpZHRoPSI4IiBoZWlnaHQ9IjE0MCIvPgogIDwvZz4KCiAgPCEtLSBUZXh0IC0tPgogIDx0ZXh0IHg9IjEwMCIgeT0iNjUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgSGVsdmV0aWNhLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjYwIiBmaWxsPSJ3aGl0ZSIgZm9udC13ZWlnaHQ9ImJvbGQiPgogICAgS2VpdGjigJlzCiAgPC90ZXh0PgogIDx0ZXh0IHg9IjEwMCIgeT0iMTI1IiBmb250LWZhbWlseT0iQXJpYWwsIEhlbHZldGljYSwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSI2MCIgZmlsbD0id2hpdGUiIGZvbnQtd2VpZ2h0PSJib2xkIj4KICAgIEhhaXJjZW50ZXIKICA8L3RleHQ+Cjwvc3ZnPg==";